import React from "react";
import { Helmet } from "react-helmet-async";
import HomeView from "../views/home";

function HomePage() {
  return (
    <>
      {/* SEO: Add "bbgfood", "BBG", and "bbg" to the title and meta description */}
      <Helmet>
        <title>BBG </title>
        <meta
          name="description"
          content="Welcome to bbgfood! Explore our menu and order online"
        />
        
        <link rel="canonical" href="https://www.bbgfood.com" />
        
      </Helmet>

      <HomeView/>
    </>
  );
}

export default HomePage;
